const DOMAIN_PREFIX = "sc-domain:";

// Google's favicon endpoint wants an http(s) page URL. A domain property names
// the host itself, so sc-domain:suchen.mobile.de is https://suchen.mobile.de/.
// Prepending www. looks up a different host: www.suchen.mobile.de has no
// favicon, while suchen.mobile.de does. Keeping the sc-domain: prefix also
// 404s, because it is not a page URL.
function faviconPageUrl(propertyUrl: string): string | null {
  const raw = propertyUrl.trim();
  if (!raw) {
    return null;
  }
  if (!raw.toLowerCase().startsWith(DOMAIN_PREFIX)) {
    return raw;
  }
  const domain = raw
    .slice(DOMAIN_PREFIX.length)
    .replace(/^\/+|\/+$/g, "")
    .split("/")[0]
    .trim()
    .toLowerCase();
  if (!domain) {
    return null;
  }
  return `https://${domain}/`;
}

export function propertyFaviconSrc(
  propertyUrl: string | undefined,
  size = 32
): string | null {
  const raw = propertyUrl?.trim();
  if (!raw) {
    return null;
  }
  const pageUrl = faviconPageUrl(raw);
  if (!pageUrl) {
    return null;
  }
  return `https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${encodeURIComponent(
    pageUrl
  )}&size=${size}`;
}
